/**
 * Yetki yok ekranı.
 *
 * Neden ayrı bir ekran: kullanıcı adres çubuğuna `/ayarlar` yazdığında ya da
 * eski bir bağlantıya tıkladığında karşısına çıplak bir hata değil, ne olduğunu
 * ve ne yapacağını söyleyen bir sayfa çıkmalı. Menüde zaten görünmüyor; buraya
 * gelmek istisnai bir durumdur ve açıklanmayı hak eder.
 */

import { Link } from 'react-router';
import { ArrowLeft, ShieldOff } from 'lucide-react';
import { Kabuk } from '../components/Kabuk';
import { Kart } from '../components/ui/Kart';
import { Dugme } from '../components/ui/Dugme';
import { BosDurum } from '../components/Durumlar';
import { useOturum } from '../oturum';

/** İzin anahtarını insan diline çevirir — ekranda `rol.duzenle` görünmez. */
const IZIN_ETIKETI: Record<string, string> = {
  'fatura.goruntule': 'faturaları görme',
  'fatura.duzenle': 'fatura işlemleri',
  'belge.goruntule': 'belge indirme',
  'musteri.goruntule': 'müşteri kimlik verisi',
  'kullanici.goruntule': 'kullanıcıları görme',
  'kullanici.duzenle': 'kullanıcı yönetimi',
  'kullanici.sil': 'kullanıcı silme',
  'rol.goruntule': 'rolleri görme',
  'rol.duzenle': 'rol yönetimi',
  'rol.sil': 'rol silme',
  'ayar.goruntule': 'ayarları görme',
  'ayar.duzenle': 'ayarları değiştirme',
  'gizli.duzenle': 'şifre ve anahtar girme',
  'sablon.goruntule': 'şablonları görme',
  'sablon.duzenle': 'şablon düzenleme',
  'bildirim.goruntule': 'bildirim kayıtları',
  'hata.goruntule': 'hata kayıtlarını görme',
  'hata.duzenle': 'hata kaydı kapatma',
  'kayit.goruntule': 'işlem kaydı',
};

/**
 * Tabloda olmayan izin için ham kodu göstermek yerine okunur hâle getir
 * (CLAUDE.md kural 6). Yeni bir alan eklendiğinde bu tablo unutulsa bile
 * ekranda "rol.sil" değil "rol → sil" görünür.
 */
function izinEtiketi(izin: string): string {
  const hazir = IZIN_ETIKETI[izin];
  if (hazir) return hazir;
  const [alan, eylem] = izin.split('.');
  const EYLEM: Record<string, string> = { goruntule: 'görme', duzenle: 'düzenleme', sil: 'silme' };
  return `${alan ?? izin} ${EYLEM[eylem ?? ''] ?? eylem ?? ''}`.trim();
}

export function YetkiYok({ izin }: { izin: string }) {
  const { kullanici } = useOturum();
  const etiket = izinEtiketi(izin);

  return (
    <Kabuk baslik="Yetkiniz yok" altBaslik="Bu sayfa size kapalı">
      <Kart>
        <BosDurum
          ikon={<ShieldOff size={32} strokeWidth={1.5} />}
          baslik="Bu sayfayı görüntüleyemezsiniz"
          aciklama={
            `Bu ekran "${etiket}" yetkisi ister. ` +
            `Rolünüz: ${kullanici?.roleName ?? 'bilinmiyor'}. ` +
            'Erişim gerekiyorsa bir yöneticiden bu yetkiyi vermesini isteyin.'
          }
          eylem={
            <Link to="/faturalar">
              <Dugme gorunum="ikincil" ikon={<ArrowLeft size={15} />}>
                Faturalara dön
              </Dugme>
            </Link>
          }
        />
      </Kart>
    </Kabuk>
  );
}
